// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6adc1319","453":"352c3575","455":"149f8262","977":"92fdd8d7"}[chunkId] + ".chunk.js";
};